import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header, Footer } from './components/HeaderFooter';
import HeroSection from './components/HeroSection';
import { PropertyHighlights, PropertyDetails, Reviews, BookingCTA } from './components/PropertySection';
import AttractionsSection from './components/AttractionsSection';
import SeasonalSection from './components/SeasonalSection';
import AvailabilitySection from './components/AvailabilitySection';
import OrganizedGallery from './components/OrganizedGallery';
import MapSection from './components/MapSection';
import WeatherWidget from './components/WeatherWidget';
import GuidebookSection from './components/GuidebookSection';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './styles/maine-coastal.css';

const HomePage = () => {
  useEffect(() => {
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href !== '#') {
          e.preventDefault();
          const target = document.querySelector(href);
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });

    // Scroll reveal animation
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    }, observerOptions);

    // IMPORTANT: Add scroll-reveal class FIRST, then observe
    const sections = document.querySelectorAll('section:not(#hero)');
    sections.forEach(section => {
      section.classList.add('scroll-reveal');
    });

    // Now observe all scroll-reveal elements (including the ones just added)
    document.querySelectorAll('.scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    // Safety fallback: reveal all sections after 2s in case observer fails
    const fallbackTimer = setTimeout(() => {
      document.querySelectorAll('.scroll-reveal').forEach(el => {
        el.classList.add('revealed');
      });
    }, 2000);

    return () => {
      observer.disconnect();
      clearTimeout(fallbackTimer);
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh' }}>
      <Header />
      <main>
        <HeroSection />
        <div id="highlights">
          <PropertyHighlights />
        </div>
        <PropertyDetails />
        <div id="gallery">
          <OrganizedGallery />
        </div>
        <div id="reviews">
          <Reviews />
        </div>
        <GuidebookSection />
        <AttractionsSection />
        <MapSection />
        <WeatherWidget />
        <SeasonalSection />
        <AvailabilitySection />
        <BookingCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
